import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';
import {
  FaHome, FaUserMd, FaConciergeBell, FaPen,
  FaCalendarCheck, FaSignOutAlt,
} from 'react-icons/fa';

const NAV_ITEMS = [
  { section: 'Main', links: [
    { to: '/admin/dashboard', icon: <FaHome />, label: 'Dashboard' },
  ]},
  { section: 'Manage', links: [
    { to: '/admin/doctors',      icon: <FaUserMd />,        label: 'Doctors' },
    { to: '/admin/services',     icon: <FaConciergeBell />, label: 'Services' },
    { to: '/admin/blog',         icon: <FaPen />,           label: 'Blog Posts' },
    { to: '/admin/appointments', icon: <FaCalendarCheck />, label: 'Appointments' },
  ]},
];

const Sidebar = () => {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const initials = user?.username
    ? user.username.slice(0, 2).toUpperCase()
    : 'AD';

  return (
    <aside className="admin-sidebar" id="admin-sidebar">
      {/* Logo */}
      <a href="/admin/dashboard" className="admin-sidebar-logo" id="admin-sidebar-logo" style={{ background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
        <img
          src="/uk-dental-logo.png"
          alt="UK Dental Studio"
          style={{ maxHeight: '42px', maxWidth: '200px', objectFit: 'contain' }}
        />
      </a>

      {/* Nav Sections */}
      {NAV_ITEMS.map(section => (
        <div className="admin-sidebar-section" key={section.section}>
          <div className="admin-sidebar-section-label">{section.section}</div>
          {section.links.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
              id={`sidebar-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <span className="nav-icon">{link.icon}</span>
              {link.label}
            </NavLink>
          ))}
        </div>
      ))}

      {/* Footer */}
      <div className="admin-sidebar-footer" id="admin-sidebar-footer">
        <div className="admin-sidebar-user">
          <div className="admin-sidebar-avatar">{initials}</div>
          <div className="admin-sidebar-user-info">
            <span>{user?.username || 'Admin'}</span>
            <span>{user?.email || ''}</span>
          </div>
        </div>
        <button className="admin-logout-btn" onClick={handleLogout} id="admin-logout-btn">
          <FaSignOutAlt /> Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
